import { normalizeSort } from '../utils'
import VehiculoService from '../services/VehiculoService'

const state = () => ({
  list: [],
  pagination: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['status'],
    sortDesc: [false]
  },
  filters: {
    search: null,
    status: [],
    condition: [],
    dealer_id: null,
    location_id: [],
    todo_ids: [],
    estado_proceso_id: [],
    order_number: null,
    iic_number: null,
    brand: null,
    model: null,
    version: null,
    color: null,
    fuel: null,
    transmission: null,
    frame_number: null,
    plate_number: null,
    price: null,
    engine: null,
    en_movimiento: false,
    en_cesion: false
  },
  quickFilter: null
})

const getters = {
  VEHICULOS: state => {
    return state.list
  },
  VEHICULOS_PAG: state => {
    return state.pagination
  },
  VEHICULOS_FILTERS: state => {
    return state.filters
  },
  VEHICULOS_QUICK_FILTER: state => {
    return state.quickFilter
  }
}

const mutations = {
  SET_VEHICULOS: (state, payload) => {
    state.list = payload
  },
  SET_VEHICULOS_PAG: (state, payload) => {
    state.pagination = payload
  },
  SET_VEHICULOS_FILTERS: (state, payload) => {
    state.filters = { ...state.filters, ...payload }
  },
  SET_VEHICULOS_QUICK_FILTER: (state, payload) => {
    state.quickFilter = payload
  },
  RESET_VEHICULOS_FILTERS: (state) => {
    state.filters = {
      search: null,
      status: [],
      condition: [],
      dealer_id: null,
      location_id: [],
      todo_ids: [],
      estado_proceso_id: [],
      order_number: null,
      iic_number: null,
      brand: null,
      model: null,
      version: null,
      color: null,
      fuel: null,
      transmission: null,
      frame_number: null,
      plate_number: null,
      price: null,
      engine: null,
      en_movimiento: false,
      en_cesion: false
    }
    state.quickFilter = null
  },
  DELETE_VEHICULOS: (state, payload) => {
    payload.status = 0
    payload.status_description = 'Deshabilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ENABLE_VEHICULOS: (state, payload) => {
    payload.status = 1
    payload.status_description = 'Habilitado'
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  },
  ADD_VEHICULOS: (state, payload) => {
    state.list.push(payload)
  },
  UPDATE_VEHICULOS: (state, payload) => {
    state.list = state.list.map(el => el.id === payload.id ? payload : el)
  }
}

const actions = {
  LOAD_VEHICULOS: async ({ commit, state }, filter) => {
    try {
      let pagination = {
        'page': state.pagination.page,
        'per-page': state.pagination.itemsPerPage,
        'sort': normalizeSort(state.pagination.sortBy, state.pagination.sortDesc)
      }

      let currentFilter = {}
      for (let key in filter) {
        if (filter.hasOwnProperty(key)) {
          currentFilter[`filter[${key}]`] = filter[key]
        }
      }

      let { data, status } = await VehiculoService.get({ ...currentFilter, ...pagination })
      if (status === 200) {
        console.log('[LOAD_VEHICULOS] respuesta API', {
          total: data._meta ? data._meta.totalCount : null,
          ejemplo: data.data[0] ? {
            id: data.data[0].id,
            status: data.data[0].status,
            exceptional_movement: data.data[0].exceptional_movement,
            dealer_id: data.data[0].dealer_id,
            location_id: data.data[0].location_id,
            dealer: data.data[0].dealer ? data.data[0].dealer.name : null
          } : null,
          con_excepcional: data.data.filter(v => v.exceptional_movement).length
        })
        commit('SET_VEHICULOS', data.data)
        return data._meta.totalCount
      }
    } catch (error) {
      window.app.$toast.error('Ocurrió un problema al intentar obtener la lista de vehiculos')
      console.error(error)
    }
  },
  VIEW_VEHICULOS: async (obj, params) => {
    try {
      let { data, status } = await VehiculoService.view(params)
      if (status === 200) {
        return data
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar obtener los detalles de los vehiculos')
    }
  },
  ADD_VEHICULOS: async ({ commit }, payload) => {
    try {
      let { data, status } = await VehiculoService.post(payload)
      if (status === 201) {
        commit('ADD_VEHICULOS', data)
        window.app.$toast.success('El vehiculo ha sido registrado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  UPDATE_VEHICULOS: async ({ commit }, payload) => {
    try {
      let { data, status } = await VehiculoService.put(payload)
      if (status === 200) {
        commit('UPDATE_VEHICULOS', data)
        window.app.$toast.success('El vehiculo ha sido actualizado satisfactoriamente')
      }
      return { error: false, data, status }
    } catch (error) {
      return { error: true, data: error.response.data, status: error.response.status }
    }
  },
  DELETE_VEHICULOS: async ({ commit }, payload) => {
    try {
      let { status } = await VehiculoService.delete(payload)
      if (status === 204) {
        commit('DELETE_VEHICULOS', payload)
        window.app.$toast.success('El vehiculo ha sido deshabilitado satisfactoriamente')
      }
    } catch (error) {
      console.error(error)
      window.app.$toast.error('Ocurrió un problema al intentar deshabilitar el usuario')
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
